<template>
    <div>
        <form action="" @submit.prevent>
            <div class="field has-addons lb-message-input">
                <div
                    :style="`height:${height};`"
                    class="control is-expanded lb-clean-input lb-grow"
                >
                    <textarea
                        v-if="!hasEditor"
                        ref="messageInput"
                        v-model="message"
                        :placeholder="$t('Object.comments_input_placeholder')"
                        :style="`height:${height};`"
                        class="
                            textarea
                            has-fixed-size
                            is-small is-size-6
                            lb-grow
                        "
                        type="text"
                        @keydown.@="markMentionStart"
                        @keydown="setAutoHeight"
                        @input="fetchUsers"
                        @keyup.esc="showUserDropdown = false"
                        @keyup.space="showUserDropdown = false"
                        @keyup.enter="sendMessage"
                    />
                    <input-rich-text
                        v-else
                        ref="messageInput"
                        :suggestions="suggestions"
                        v-model="message"
                        :placeholder="$t('Object.comments_input_placeholder')"
                    />
                </div>
                <div v-if="!showCancel" class="control">
                    <button
                        :disabled="!message.length"
                        :content="message"
                        class="
                            button
                            is-text
                            has-text-primary
                            is-primary is-inverted
                        "
                        @click="sendMessage"
                    >
                        <span class="icon is-medium">
                            <i class="mdi mdi-18px mdi-send"></i>
                        </span>
                    </button>
                </div>
            </div>
            <app-mentions-dropdown
                v-if="showUserDropdown"
                :items="users"
                :loading="loading"
                @select="addUser"
            />
        </form>
        <div class="buttons has-addons is-right">
            <button
                v-if="showCancel"
                v-t="'Buttons.cancel'"
                class="button is-ghost is-uppercase has-text-pink-red"
                @click="$emit('cancel')"
            ></button>
            <button
                v-if="showCancel"
                v-t="'Buttons.update'"
                class="
                    button
                    is-ghost is-uppercase is-paddingless
                    has-text-pink-red
                "
                @click="sendMessage"
            ></button>
        </div>
    </div>
</template>

<script>
import AppMentionsDropdown from '@/components/AppMentionsDropdown';
import InputRichText from '@/components/InputRichText';
import { fetchItems } from '@/services/API';
export default {
    components: {
        AppMentionsDropdown,
        InputRichText,
    },
    props: {
        preMessage: {
            type: String,
            default: '',
        },
        showCancel: {
            type: Boolean,
            default: false,
        },
        hasEditor: {
            type: Boolean,
            default: false,
        },
        suggestions: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            message: this.preMessage,
            showUserDropdown: false,
            loading: true,
            users: [],
            regex: new RegExp('@[0-9a-z]*', 'g'),
            mentionStart: 0,
            height: undefined,
        };
    },
    computed: {
        currentMention() {
            return this.message.substring(
                this.mentionStart,
                this.$refs.messageInput.selectionStart
            );
        },
    },
    watch: {
        preMessage() {
            this.message = this.preMessage;
        },
        message() {
            if (!this.message.length) {
                this.showUserDropdown = false;
            }
        },
        users() {
            if (!this.users.length) {
                this.showUserDropdown = false;
            }
        },
    },
    mounted() {
        this.setAutoHeight();
    },
    methods: {
        markMentionStart() {
            // console.log('@ pressed');
            this.showUserDropdown = true;
            this.mentionStart = this.$refs.messageInput.selectionStart;
        },
        async fetchUsers() {
            if (!this.showUserDropdown || !this.message.length) {
                return;
            }
            if (this.currentMention.length < 2) {
                return;
            }
            this.loading = true;
            let result = await fetchItems('profile', {
                username_contains: this.currentMention.replace('@', ''),
            });
            this.users = result.data;
            this.loading = false;
        },
        addUser(user) {
            const prementionString = this.message.substring(
                0,
                this.mentionStart - 1
            );
            const mentionString = this.message.substring(this.mentionStart - 1);
            this.message =
                prementionString +
                ' @' +
                mentionString
                    .replace(this.currentMention, user.username)
                    .trim();

            this.mentionedUsers.push(user.owner);
            this.showUserDropdown = false;
            this.users.length = 0;
        },
        sendMessage() {
            this.$emit('comment', this.message);
            this.message = '';
            this.height = 'auto';
            this.setAutoHeight();
        },
        setAutoHeight() {
            this.$nextTick(() => {
                if (this.$refs.messageInput) {
                    let totalHeight = this.$refs.messageInput.scrollHeight;
                    this.height = `${totalHeight}px`;
                }
            });
        },
    },
};
</script>

<style scoped>
.lb-message-input {
    position: relative;
    bottom: 0;
}

.lb-grow {
    min-height: 2rem;
    max-height: 8rem;
    border-color: transparent;
}
</style>
